export default "__VITE_PUBLIC_ASSET__f517877b__"